import { Component, OnInit } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import jsPDF from 'jspdf';
import { SysService } from 'src/app/modules/sys/services/sys.service';
import { forkJoin } from 'rxjs';
import { ImageUrlPipe } from "../../../../../pipe/image-url.pipe";
 
const ROWS_PER_PAGE = 20;


@Component({
  selector: 'app-report-viewer',
  imports: [CommonModule, ImageUrlPipe],
  templateUrl: './report-viewer.component.html',
  styleUrl: './report-viewer.component.scss'
})



export class ReportViewerComponent implements OnInit {
  data: any | null = null;
  pages: any[][] = [];
  totalDr = 0;
  totalCr = 0;
  finalBalance = 0;
  today = new Date().toLocaleDateString('en-GB', {
    weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric',
  });
 
  constructor(
    private sysService :SysService
  ){}


  ngOnInit(): void {
  const raw = sessionStorage.getItem('reportData');

  if (!raw) {
    console.warn('No report data found');
    return;
  }

  try {
    const parsed = JSON.parse(raw);

    this.data = {
      transactions: parsed
    };

     this.paginate(this.data.transactions);
     this.calcTotals(this.data.transactions);

  } catch (e) {
    console.error('Error parsing report data', e);
  }


  this.getConfigKeys()
}
  companyName: any
  companyLogo: any
  getConfigKeys() {
  forkJoin({
    name: this.sysService.getConfigByKey('COMPANY_NAME'),
    logo: this.sysService.getConfigByKey('COMPANY_LOGO')
  }).subscribe(({ name, logo }) => {
    if (name.isSuccess) {
      this.companyName = name.data.configValue;
    }

    if (logo.isSuccess) {
      this.companyLogo = logo.data.configValue;
    }
  });
}
 
  private paginate(rows: any[]): void {
    this.pages = [];
    for (let i = 0; i < rows.length; i += ROWS_PER_PAGE) {
      this.pages.push(rows.slice(i, i + ROWS_PER_PAGE));
    }
    //  for (let i = 0; i < rows.length; i += ROWS_PER_PAGE) {
    //   this.pages.push(rows.slice(i, i ));
    // }
  }
 
  private calcTotals(rows: any[]): void {
    this.totalDr = rows.reduce((s, r) => s + (r.dr ?? 0), 0);
    this.totalCr = rows.reduce((s, r) => s + (r.cr ?? 0), 0);
    this.finalBalance = rows[rows.length - 1]?.balance ?? 0;
  }
 
  print(): void {
    window.print();
  }
 
  async downloadPdf(): Promise<void> {
    const { default: jsPDF } = await import('jspdf');
    const { default: html2canvas } = await import('html2canvas');
 
    const pagesEl = document.getElementById('report-pages');
    if (!pagesEl) return;
 
    const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const pageEls = pagesEl.querySelectorAll<HTMLElement>('.page');
 
    for (let i = 0; i < pageEls.length; i++) {
      const canvas = await html2canvas(pageEls[i], { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/png');
      const pdfW = pdf.internal.pageSize.getWidth();
      const pdfH = (canvas.height * pdfW) / canvas.width;
 
      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, 0, pdfW, pdfH);
    }
 
    const filename = `${this.data?.config?.reportTitle ?? 'report'}_${Date.now()}.pdf`;
    pdf.save(filename);
  }
}
